<div id="sankey_multiple">
    <div class="row">
        <div class="staticb">A1.2 BUILDING LOADS </div>


    </div>

    <div id="snkcharts" class="row">

        <div class="col-6">
            <div id="chartsix"></div>
            <button mat-button id="coolingbtn" (click)="chartCooling()">Impact on Cooling</button>

            <div id="chartcoolingnew"></div>





            <div id="cooling_load">Total cooling peak load : {{total_cooling_load | number:'1.1-2'}}</div>



            <span id="text" class="d-none">Checkbox is CHECKED!</span>

        </div>


        <div class="col-6">

            <button mat-button id="heatingbtn" (click)="chartHeatingSolar()">Impact on Heating</button>

            <div id="heatingnew"></div>
            <div id="heating_load">Total heating peak load : {{total_heating_load | number:'1.1-2'}}</div>


        </div>

    </div>





</div>